import { useState, useMemo, useEffect } from "react";
import { FiSearch, FiX, FiChevronUp, FiChevronDown } from "react-icons/fi";
import useChatStore from "../../store/chatStore";
import styles from "./MessageSearchBar.module.css";

const MessageSearchBar = ({ onClose, onJump }) => {
  const { messages } = useChatStore();
  const [query, setQuery] = useState("");
  const [cursor, setCursor] = useState(0);

  const results = useMemo(() => {
    if (!query.trim()) return [];
    const q = query.toLowerCase();
    return messages
      .map((m, idx) => ({ ...m, idx }))
      .filter((m) => m.text?.toLowerCase().includes(q));
  }, [query, messages]);

  const total = results.length;

  // Auto-jump to first result as you type
  useEffect(() => {
    if (total > 0) {
      setCursor(0);
      onJump(results[0]._id);
    }
  }, [total, query]);

  const jump = (dir) => {
    if (total === 0) return;
    const next = ((cursor + dir) % total + total) % total;
    setCursor(next);
    onJump(results[next]._id);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (e.shiftKey) jump(-1);
      else jump(1);
    }
    if (e.key === "Escape") onClose();
  };

  return (
    <div className={styles.bar}>
      <FiSearch size={15} className={styles.searchIcon} />

      <input
        className={styles.input}
        placeholder="Search messages…"
        value={query}
        onChange={(e) => { setQuery(e.target.value); setCursor(0); }}
        onKeyDown={handleKeyDown}
        autoFocus
      />

      {/* Count + nav arrows grouped together */}
      {query.trim() && (
        <div className={styles.navGroup}>
          <button className={styles.navArrow} onClick={() => jump(-1)} disabled={total === 0} title="Previous">
            <FiChevronUp size={14} />
          </button>
          <span className={styles.count}>
            {total > 0 ? `${cursor + 1} / ${total}` : "No results"}
          </span>
          <button className={styles.navArrow} onClick={() => jump(1)} disabled={total === 0} title="Next">
            <FiChevronDown size={14} />
          </button>
        </div>
      )}

      {/* Close */}
      <button className={styles.closeBtn} onClick={onClose} title="Close (Esc)">
        <FiX size={16} />
      </button>
    </div>
  );
};

export default MessageSearchBar;
